// A kontír-szerkesztő (K2D w_popup_fokonyv) modelljei. A tétel a prefixenkénti
// <acc_table> sor képe, a bontás a <acc_table>_d soré — a dimCode itt SZÖVEGES
// kód (nvarchar(10)), nem id, mint a tranzakciós dimenzióknál.

export interface PreAccEditDimension {
  id: number;            // szam; <= 0 = új (negatív temp id)
  head: number;          // kontírtétel szam (új tételnél annak negatív temp id-ja)
  dimCodeType: number;   // csaccdimcodetype: 5 = IV. ... 13 = XII.
  dimCode: string;
  total: number;

  // Kísérő mezők (K2D d_g_accitem_d_new láthatóság-térkép szerint fülenként)
  extProdParts: number;
  extProdPartsCode: string;
  extProdPartsName: string;
  productParts: number;
  productPartsCode: string;
  productPartsName: string;
  // VI. dimenzió: cikk (parts_id) — az auto-kontír is ezt tölti
  partsId: number;
  partsCode: string;
  partsName: string;
  production: number;
  stock: number;
  carId: number;
  regNum: string;
  userId: number;
  userName: string;
  stationId: number;
  stationName: string;
  toolId: number;
  toolName: string;
  project: number;
  projectName: string;
  projectMainCode: string;
  projectCode: string;
  poId: number;
  poNumber: string;
  workNumber: string;
  extProdPartner: number;
  extProdPartnerName: string;

  inEdit: boolean;
  selected: boolean;
  deleting: boolean;
}

export const PreAccEditDimensionDefaultProps: PreAccEditDimension = {
  id: 0,
  head: 0,
  dimCodeType: 5,
  dimCode: "",
  total: 0,

  extProdParts: 1,
  extProdPartsCode: "",
  extProdPartsName: "",
  productParts: 1,
  productPartsCode: "",
  productPartsName: "",
  partsId: 1,
  partsCode: "",
  partsName: "",
  production: 1,
  stock: 1,
  carId: 1,
  regNum: "",
  userId: 1,
  userName: "",
  stationId: 1,
  stationName: "",
  toolId: 1,
  toolName: "",
  project: 1,
  projectName: "",
  projectMainCode: "",
  projectCode: "",
  poId: 1,
  poNumber: "",
  workNumber: "",
  extProdPartner: 1,
  extProdPartnerName: "",

  inEdit: false,
  selected: false,
  deleting: false,
};

export interface PreAccEditItem {
  id: number;            // szam; <= 0 = új (negatív temp id, K2D il_accitem_id minta)
  accCode: string;
  accCodeName: string;   // sfp_accno_nat párja, csak megjelenítés
  accSign: string;       // '+' = Tartozik, '-' = Követel
  dimType: number;       // könyvelési típus (csbokbooktype.szam)
  detailedType: number;  // részletezés típus (csbokaccnodettype.szam)
  total: number;
  currency: string;
  accDate: string;
  dimCode1: string;
  dimCode2: string;
  dimCode3: string;
  note: string;
  period: number;
  currTotal: number;
  exchangeRate: number;
  car: number;
  prcar: number;
  project: number;
  poId: number;
  // MIX tétel készlet-cikke (K2D d_g_mixitem csak-olvasó oszlopai) — csak megjelenítés
  partsCode: string;
  partsName: string;
  partGroupCode: string;
  partGroupName: string;

  inEdit: boolean;
  selected: boolean;
  deleting: boolean;
  // Kijelölés a sablonos módosításhoz (K2D 'sel' oszlop): a sablon ezekre a sorokra
  // érvényesít. A `selected` az AKTUÁLIS (fókuszált) sor kiemelése — a kettő független.
  marked: boolean;
  // Új (még nem mentett) tételhez fűzött bontás-sorok — mentéskor a tétellel együtt mennek
  newDimensions: PreAccEditDimension[];
}

export const PreAccEditItemDefaultProps: PreAccEditItem = {
  id: 0,
  accCode: "",
  accCodeName: "",
  accSign: "+",
  dimType: 1,
  detailedType: 6,
  total: 0,
  currency: "HUF",
  accDate: "",
  dimCode1: "",
  dimCode2: "",
  dimCode3: "",
  note: "",
  period: 1,
  currTotal: 0,
  exchangeRate: 1,
  car: 1,
  prcar: 1,
  project: 1,
  poId: 1,
  partsCode: "",
  partsName: "",
  partGroupCode: "",
  partGroupName: "",

  inEdit: false,
  selected: false,
  deleting: false,
  marked: false,
  newDimensions: [],
};

// Sablonos módosítás (K2D n_cst_template / d_f_template): a kijelölt tételekre
// érvényesítendő értékek + mezőnként az „érvényesüljön-e" jelölő.
// A PÉNZNEMNEK nincs jelölője — a K2D d_f_template űrlapján sincs kirakva a
// currency_b checkbox, ezért ott mindig érvényesül; nálunk is így viselkedik.
export interface PreAccItemTemplate {
  accCode: string;
  accCodeName: string;
  total: number;
  /// Jelölő nélküli mező: a sablon alkalmazásakor mindig érvényesül (K2D-hű)
  currency: string;
  accDate: string;
  note: string;
  dimType: number;
  dimCode1: string;
  dimCode2: string;
  dimCode3: string;
  detailedType: number;

  applyAccCode: boolean;
  applyTotal: boolean;
  applyAccDate: boolean;
  applyNote: boolean;
  applyDimType: boolean;
  applyDimCode1: boolean;
  applyDimCode2: boolean;
  applyDimCode3: boolean;
  applyDetailedType: boolean;
}

// A szerkesztő fej-panelje (K2D dw_1 / d_f_invoice látható mezői)
export interface PreAccEditorHead {
  code: string;          // prefix kód (GENI, ...)
  invNo: number;
  prefix: string;        // magyar prefix (BEJÖ, ...)
  outerInNo: string;
  k2dInvNo: string | null;
  status: number;
  statusName: string;
  accStatus: number;
  accStatusName: string;
  netto: number;
  vat: number;
  total: number;
  currency: string;
  partner: number;
  partnerName: string;
  bodyNo: string;
  invDate: string;
  shipDate: string;
  accDate: string;
  shipDateC: boolean;    // folyamatos teljesítés — az accDate mező csak ekkor látszik
  isVatScaling: boolean; // csak GENI-nél szerkeszthető
  isSelfBilling: boolean;
  accGroup: number | null;
  hasAccGroup: boolean;  // van-e acc_group oszlop a számlatáblában
  accNoRestricted: boolean; // sfp_accno_user kapu: van tiltott fk. szám → teljes read-only

  // MIX gyűjtőbizonylat fej (K2D w_response_mix / d_f_mixhead)
  isMix: boolean;
  invType: number;
  invTypeName: string;
  // K2D csaccmixtype.is_acc_date_mod = '+': a könyvelési dátum utólag módosítható
  // (a gomb a bizonylatot ÚJRAGENERÁLJA, nem a tételek dátumát írja át)
  accDateModifiable: boolean;
  // K2D csaccmixtype.stock_value_diff — 1 fölött készletérték-különbözetes (KÉK)
  // bizonylat: ilyenkor a fejben a Cikk és a Periódus is kötelező
  stockValueDiff: number;
  parts: number;
  partsCode: string;
  partsName: string;
  period: number;
  periodName: string;
  storeIn: number;
  gStoreIn: number;
  storeOut: number;
  accEvent: string;
  note: string;
  insDate: string;
  insTime: string;
  userName: string;
  currTotal: number;
  exchangeRate: number;
  invCurrency: string;
  production: string;       // Gyártási lejelentés
  sheetOper: string;        // Feladatkartya
  contTemplate: string;     // Kontírozási sablon
  wageWorkPack: string;     // Bérmunka csomag
  classification: string;   // Osztályozás azonosító
  poNumber: string;         // Gyártásrendelés szám
  sourceTypeName: string;   // Forrásbizonylat típusa
  sourceHead: number;       // Forrásbizonylat azonosítója
}

export const PreAccEditorHeadDefaultProps: PreAccEditorHead = {
  code: "",
  invNo: 0,
  prefix: "",
  outerInNo: "",
  k2dInvNo: null,
  status: 1,
  statusName: "",
  accStatus: 1,
  accStatusName: "",
  netto: 0,
  vat: 0,
  total: 0,
  currency: "HUF",
  partner: 1,
  partnerName: "",
  bodyNo: "",
  invDate: "",
  shipDate: "",
  accDate: "",
  shipDateC: false,
  isVatScaling: false,
  isSelfBilling: false,
  accGroup: null,
  hasAccGroup: false,
  accNoRestricted: false,

  isMix: false,
  invType: 1,
  invTypeName: "",
  accDateModifiable: false,
  stockValueDiff: 1,
  parts: 1,
  partsCode: "",
  partsName: "",
  period: 1,
  periodName: "",
  storeIn: 1,
  gStoreIn: 1,
  storeOut: 1,
  accEvent: "",
  note: "",
  insDate: "",
  insTime: "",
  userName: "",
  currTotal: 0,
  exchangeRate: 1,
  invCurrency: "",
  production: "",
  sheetOper: "",
  contTemplate: "",
  wageWorkPack: "",
  classification: "",
  poNumber: "",
  sourceTypeName: "",
  sourceHead: 1,
};

//----------- Mentés (K2D pb_ok) -----------//

// A kliens a TELJES kívánt állapotot küldi + a törölt azonosítókat; a negatív id új sor.
export interface PreAccSaveRequest {
  originalAccStatus: number;
  isVatScaling: boolean;
  accGroup: number | null;
  // csak KÉK MIX bizonylaton értelmezett
  parts?: number;
  period?: number;
  // KÉK MIX fej (K2D w_response_mix: stock_value_diff > 1 → ii_oper 3, a fej is írható);
  // a backend csak MIX KÉK bizonylaton veszi figyelembe
  accDate?: string;
  accEvent?: string;
  note?: string;
  invType?: number;
  items: {
    id: number;
    accCode: string;
    accSign: string;
    dimType: number;
    detailedType: number;
    total: number;
    currency: string;
    accDate: string;
    dimCode1: string;
    dimCode2: string;
    dimCode3: string;
    note: string;
  }[];
  dimensions: {
    id: number;
    head: number;
    dimCodeType: number;
    dimCode: string;
    total: number;
    project: number;
    poId: number;
    userId: number;
    stationId: number;
    toolId: number;
    carId: number;
    extProdParts: number;
    extProdPartner: number;
    productParts: number;
    // VI. dimenzió kísérője: cikk (parts_id)
    partsId: number;
    production: number;
    stock: number;
  }[];
  deletedItemIds: number[];
  deletedDimensionIds: number[];
}

// Információs adatlapok (K2D pb_info = prefix szerinti forrás-adatok, pb_info2 = általános)
export interface PreAccInfoField {
  label: string;
  value: string;
}

// A számlához csatolt dokumentum (K2D dw_geni_pict) — csak szállítói számlánál
export interface PreAccInvoiceDoc {
  id: number;
  fileName: string;
  description: string;
  docTypeName: string;
}

export interface PreAccInvoiceInfo {
  prefixTitle: string;
  prefixFields: PreAccInfoField[];
  generalFields: PreAccInfoField[];
  documents: PreAccInvoiceDoc[];
}

// Költséghely-bontás (K2D b_acc_group gomb → w_popup_accgritem), olvasásra.
// A K2D felső gridje a számla tételei, az alsó a kijelölt tétel bontás-sorai.
export interface PreAccAccGroupItem {
  id: number;
  name: string;
  netto: number;
  accGroup: number;
  accGroupName: string;
  accGroupTempl: number;
  accGroupTemplName: string;
  splitNetto: number;
}

export interface PreAccAccGroupSplitRow {
  id: number;
  invItem: number;
  invItemName: string;
  accGroup: number;
  accGroupName: string;
  netto: number;
  dimCode2: string;
}

export interface PreAccAccGroupSplit {
  invoiceNetto: number;
  sumNetto: number;
  items: PreAccAccGroupItem[];
  rows: PreAccAccGroupSplitRow[];
}

export interface PreAccSaveError {
  id: number;
  errType: number;
  errTypeName: string;
  note: string;
}

export interface PreAccSaveResult {
  accStatus: number;
  accStatusName: string;
  statusChanged: boolean;
  errors: PreAccSaveError[];
}

export interface PreAccReAccountResult {
  accStatus: number;
  accStatusName: string;
  errors: PreAccSaveError[];
}

// Fk. szám lookup-sor (mmbokaccno az acc_date évére, status=3)
export interface PreAccAccNo {
  id: number;
  accNo: string;
  name: string;
  mainTypeName: string;
  detailedType: number;
}

// Dimenziókód lookup-sor (mmbokdimcode az évre; type: 2/3/4 = dim1/2/3)
export interface PreAccDimCode {
  id: number;
  dimcode: string;
  national: string;
  type: number;
}

// MIX bizonylat-típus (csaccmixtype) az új felvitel Típus-mezőjéhez. A flagek döntik el,
// hogy a három tároló-mező közül melyik választható (K2D w_response_mix buttonclicked
// kapui) — egy típushoz pontosan egy mozgásfajta tartozik.
export interface PreAccMixType {
  id: number;
  name: string;
  isStock: boolean;   // '-' esetén egyik tároló-mező sem választható
  isOut: boolean;     // '+' → Kitárolás
  isFactory: boolean; // '+' → Gyári betárolás, '-' → Egyéb betárolás
  stockValueDiff: number; // 1 fölött készletérték-különbözetes (KÉK) típus
}

// Kiválasztható betárolás/kitárolás bizonylat az új MIX felvitelhez (K2D w_popup_storein_out)
export interface PreAccStoreDoc {
  id: number;
  docDate: string;      // betárolásnál deliv_date, kitárolásnál st_out_date
  certifNo: string;
  delivInvNo: string;
  depotName: string;
  receiver: string;     // kitárolás átvevője
  partnerId: number;
  partnerName: string;
  total: number;        // a kontírozható készlet-sorok összege (K2D pb_ok lde_total)
  currTotal: number;
  invCurrency: string;
  geniInvNo: number;    // >1: a betárolás már szerepel ezen a bejövő számlán
}

// A szerkesztő rendszer-flagjei (K2D globálok TF-párja)
export interface PreAccEditorFlags {
  extBook: boolean;              // pssyssysfile.is_ext_book
  dim49: boolean;                // pssyssysfile1.is_dim_4_9
  checkDetType: boolean;         // pssyssysfile1.is_check_det_type — a detailed_type oszlop POZÍCIÓJA (nem láthatóság)
  book: boolean;                 // pssyssysfile.is_book — a Feladás gomb csak ekkor látszik (K2D gb_book)
  projectMenu: boolean;          // pssyssysfile1.is_project (K2D gb_project) — a GENI "Projekt" gomb kapuja
  dimTypeLive: Record<number, boolean>; // csaccdimcodetype.szam (2..13) → élő-e
}

// A belső főkönyvbe feladás (K2D pb_felad) eredménye
export interface PreAccPostResult {
  needsConfirmation: boolean;    // a periódus-kérdés még hátravan
  confirmMessage: string;
  posted: boolean;
  accStatus: number;             // 6 = Fők. rendsz. feladva, 7/8 = hiba
  accStatusName: string;
  warning: string;               // pl. lezárt ÁFA-bevallás
  errors: { id: number; errType: number; errTypeName: string; note: string }[];
}

// A szerkesztő teljes betöltési csomagja (egy round-trip)
export interface PreAccEditorData {
  head: PreAccEditorHead;
  items: PreAccEditItem[];
  dimensions: PreAccEditDimension[];
  originalAccStatus: number;     // optimista egyeztetéshez
  editable: boolean;             // acc_status ∈ {2,5,8,9} és nem accNoRestricted
  reAccountable: boolean;        // acc_status ∈ {2,5,7,8,9}
  accNos: PreAccAccNo[];
  dimCodes: PreAccDimCode[];
  bookTypes: { id: number; name: string }[];       // prefix-szűrt lista, első = default
  detailedTypes: { id: number; name: string }[];
  defaultDetailedType: number;   // GENI: csiniinvtype/csiniinvsubtype térkép (23), egyébként 6
  accGroups: { id: number; name: string }[];
  // KÉK bizonylat periódus-választója (mmbokperiod)
  periods: { id: number; nicName: string; fromDate: string; toDate: string }[];       // csaccinvgroup (nem-GENI fej-legördülő)
  mixTypes: PreAccMixType[];                       // csaccmixtype — az új MIX felvitel Típusa
  flags: PreAccEditorFlags;
}

// A MIX könyvelési dátum módosításának (K2D pb_acc_date → f_mix) eredménye
export interface PreAccMixAccDateResult {
  invNo: number;
  accStatus: number;
  accStatusName: string;
  accDate: string;
}

// KÉK utókalkulációs ár újraszámolás (K2D w_response_mix pb_postcalc_price) eredménye —
// kétfázisú: needsConfirmation esetén a "már módosítva" kérdést kell feltenni, majd
// confirmed=true-val újrahívni
export interface PreAccPostcalcPriceResult {
  needsConfirmation: boolean;
  confirmMessage: string;
  parts: number;
  period: number;
}

// Új MIX bizonylat mentésének kérése (K2D w_response_mix pb_ok) — a fej-mezők
// mellé a teljes kontír-állapot; a tétel-azonosítók negatívak (ideiglenesek)
export interface PreAccMixCreateRequest {
  invType: number;
  partner: number;
  storeIn: number;
  gStoreIn: number;
  storeOut: number;
  accGroup: number | null;
  accEvent: string;
  note: string;
  currency: string;
  total: number;
  currTotal: number;
  exchangeRate: number;
  accDate: string;
  parts: number;
  period: number;
  // ugyanaz a tétel/dimenzió szerkezet, mint a szerkesztő mentésénél
  items: PreAccSaveRequest["items"];
  dimensions: PreAccSaveRequest["dimensions"];
}

export interface PreAccMixCreateResult {
  invNo: number;
  accStatus: number;
  accStatusName: string;
  total: number;
}

// A GENI projekt-kezelő (K2D w_popup_geni_project_os) betöltési csomagja
export interface PreAccProjectLink {
  id: number;
  headType: number; // 10/11 = számla-szintű, 14 = tétel-szintű
  // a típus neve — a már nem választható típusé is
  headTypeName: string;
  itemId: number;
  itemName: string;
  amount: number;
  currency: string;
  workNumber: string;
  projectId: number;
  projectName: string;
  remark: string;
}

export interface PreAccProjectInvItem {
  id: number;
  name: string;
  quantity: number;
  netto: number;
  currNetto: number;
  // K2D dw_geni_item.amount = sfngeniitpramount: a tétel projektre berendezhető összege
  projAmount: number;
  // K2D pb_geni_item: alkatrész-beszerzés készletrendelés-tétele — kézzel nem rendelhető projekthez
  isStockOrder: boolean;
}

export interface PreAccProjectOverview {
  invNo: number;
  outerInvNo: string;
  partner: number;
  partnerName: string;
  currency: string;
  currNetto: number;
  // K2D pb_ok viszonyítási alapja: curr_netto + beszámított előlegek nettója
  currNettoWDpaym: number;
  preStatus: number;
  accStatus: number;
  // K2D pfc_postopen: a jóváhagyási állapotban módosítható-e (pssyssysfile2 kapcsolók)
  editable: boolean;
  editDisabledReason: string;
  links: PreAccProjectLink[];
  items: PreAccProjectInvItem[];
  // K2D ue_ht_filter: a választható kapcsolat-típusok (isgenprheadtypegr, is_usable)
  headTypes: PreAccProjectHeadType[];
  // K2D is_po: munkaszám-kezelés — a projekt-választó munkaszám oszlopa és szűrője
  isPo: boolean;
  // mminigeninvoice.type — 9 = alkatrész-beszerzés (K2D pb_geni készletrendelés-kérdése)
  invType: number;
  // K2D d_f_geni_project_os fej-mezői (altípus: 1 = nincs, üres)
  invTypeName: string;
  invSubtypeName: string;
  invDate: string; // yyyy-MM-dd
  remark: string;
}

// A projekt-választó egy sora (K2D dw_project = d_g_project_os)
export interface PreAccProjectChoice {
  id: number;
  code: string; // K2D "Külső ID"
  mainCode: string; // K2D "Belső ID"
  name: string;
  status: number;
  statusName: string;
  poWorkNumber: string;
}

export interface PreAccProjectHeadType {
  headType: number;
  name: string;
  isItem: boolean;
  isDefault: boolean;
}

export const PreAccProjectOverviewDefaultProps: PreAccProjectOverview = {
  invNo: 0,
  outerInvNo: "",
  partner: 1,
  partnerName: "",
  currency: "",
  currNetto: 0,
  currNettoWDpaym: 0,
  preStatus: 0,
  accStatus: 0,
  editable: true,
  editDisabledReason: "",
  links: [],
  items: [],
  headTypes: [],
  isPo: false,
  invType: 0,
  invTypeName: "",
  invSubtypeName: "",
  invDate: "",
  remark: "",
};

// A projekt-kapcsolat írásának eredménye (K2D pb_ok kérdései needsConfirmation-ként)
export interface PreAccProjectResult {
  projectName: string;
  needsConfirmation: boolean;
  confirmMessage: string;
  needsReaccount: boolean;
}

// Az ÁFA dátum ablak megnyitási csomagja (K2D w_popup_vat_date_os pfc_preopen)
export interface PreAccVatDateInfo {
  invNo: number;
  partnerName: string;
  outerInvNo: string;
  vatDate: string;
  editable: boolean;
  warnings: string[];
}

// Az ÁFA dátum módosításának eredménye (K2D pb_ok)
export interface PreAccVatDateResult {
  vatDate: string;
  changed: boolean;
  needsConfirmation: boolean;
  confirmMessage: string;
  messages: string[];
  needsReaccount: boolean;
}
